// extracted by mini-css-extract-plugin
export var downArrow = "_hg-0";
export var infoTooltipIcon = "_hg-3";
export var label = "_hg-1";
export var optionCard = "_hg-4";
export var upArrow = "_hg-2";